import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import Typography from '@material-ui/core/Typography';

import SignUpTemplateContainer from '../SignUpTemplate/SignUpTemplateContainer';
import VerifyEmailFormContainer from './VerifyEmailForm/VerifyEmailFormContainer';

const propTypes = {
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    emailIcon: PropTypes.string.isRequired,
    support: PropTypes.string.isRequired,
    btn: PropTypes.string.isRequired,
  }).isRequired,
};

export function UnstyledVerifyEmailPage({ classes }) {
  return (
    <SignUpTemplateContainer
      header="Verify Your Email Address"
      email
      subheader="We've sent you an email with a link to verify your email address. Please check your email inbox and follow the provided link to continue."
    >
      <div className={classes.root}>
        <div>
          <div className={classes.options}>
            <Typography variant="h6" align="center">
              Don&apos;t see the email?
              <br />
              Already checked your spam folder?
            </Typography>
            <VerifyEmailFormContainer />
          </div>
          <div className={classes.support}>
            <Typography variant="h6" align="center">
              Still having problems?
            </Typography>
            <Typography align="center">
              Reach out to our&nbsp;
              <a href="mailto:support@objectrocket.cloud">support team</a>.
            </Typography>
          </div>
        </div>
      </div>
    </SignUpTemplateContainer>
  );
}

const styles = (theme) => ({
  root: {
    '& a': {
      color: theme.customColors.white,
    },
  },
  options: {
    marginTop: '2rem',
  },
  support: {
    marginTop: '2.5rem',
  },
  btn: {
    marginTop: '.5rem',
  },
  emailIcon: {
    color: theme.customColors.white,
    fontSize: '7rem',
    marginTop: '1rem',
  },
});

UnstyledVerifyEmailPage.propTypes = propTypes;

export default withStyles(styles)(UnstyledVerifyEmailPage);
